export const platform = {
  name: "web"
};
